
/**
 * Get a value in a tree using a path array
 *
 * @param {Object} tree
 * @param {string[]} path
 * @param {*} defaultValue
 * @returns {*}
 */
export function getValueByPath(tree, path, defaultValue = undefined) {
  if (!Array.isArray(path) || path.length === 0) {
    throw new Error('getValueByPath: path must be a non-empty array');
  }

  let cursor = tree;

  for (let i = 0; i < path.length; i++) {
    if (cursor == null || typeof cursor !== 'object') {
      return defaultValue;
    }

    cursor = cursor[path[i]];
  }

  return cursor === undefined ? defaultValue : cursor;
}


/**
 * Set a value in a tree using a path array, without mutating the original tree
 *
 * @param {Object} tree
 * @param {string[]} path
 * @param {*} value
 * @returns {Object}
 */
export function setValueByPath(tree, path, value) {
  if (!Array.isArray(path) || path.length === 0) {
    throw new Error('setValueByPath: path must be a non-empty array');
  }

  const next = structuredClone(tree ?? {});
  let cursor = next;

  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i];

    if (
      typeof cursor[key] !== 'object' ||
      cursor[key] === null
    ) {
      cursor[key] = {};
    }

    cursor = cursor[key];
  }

  const lastKey = path[path.length - 1];

  if (value === undefined) {
    delete cursor[lastKey];
  } else {
    cursor[lastKey] = value;
  }

  return next;
}
